import { useMemo } from 'react';
import { useCurrent } from './useCurrent';
export function useStableCallback(fn) {
    const callbackRef = useCurrent(fn);
    return useMemo(() => ((...args) => { var _a; return (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef, ...args); }), 
    // ignore lint rule here because useCurrent is returning a stable ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
}
//# sourceMappingURL=useStableCallback.js.map